import { view } from "@risingstack/react-easy-state";
import Skeleton from "react-loading-skeleton";

import { isDataAvailable, isDefaultData, isWaitingForData } from "../common/utils/asyncDataUtils";

import authStore from "../stores/auth/authStore";
import contentStore from "../stores/cms/contentStore";

import ErrorAlertWithOptionalTracking from "../components/ErrorAlertWithOptionalTracking";
import CmsContentFetchWrapper from "../components/cms/CmsContentFetchWrapper";

const HOME_SLUG = "home";
const HOME_NOT_LOGGED_IN_SLUG = "home-not-logged-in";

const Home = () => {
   const isLoggedIn = authStore.isLoggedIn();

   if (isWaitingForData(contentStore.urlData) || isDefaultData(contentStore.urlData)) {
      return (
         <div data-testid="home-skeleton">
            <Skeleton height={500} />
         </div>
      );
   }

   if (isDataAvailable(contentStore.urlData)) {
      const urlDataHomeLoggedIn = contentStore.urlData.data.find((data) => data.slug === HOME_SLUG);
      const urlDataHomeNotLoggedIn = contentStore.urlData.data.find((data) => data.slug === HOME_NOT_LOGGED_IN_SLUG);

      // TODO: Add some error handling for the not-logged-in-page after the article published in production

      if (!urlDataHomeLoggedIn) {
         return (
            <ErrorAlertWithOptionalTracking
               showCloseButton={false}
               gaErrorTracking={{ context: "home", text: "content_not_found_error" }}
            >
               Fant ikke innholdet med slug '{HOME_SLUG}'
            </ErrorAlertWithOptionalTracking>
         );
      }

      if (!isLoggedIn && urlDataHomeNotLoggedIn) {
         return (
            <div className="-tw-mt-8">
               <CmsContentFetchWrapper id={urlDataHomeNotLoggedIn.id} />
            </div>
         );
      }

      return <CmsContentFetchWrapper id={urlDataHomeLoggedIn.id} />;
   }

   return (
      <ErrorAlertWithOptionalTracking showCloseButton={false} gaErrorTracking={{ context: "home", text: "loading_error" }}>
         Det oppsto en uventet feil under lasting av forsiden
      </ErrorAlertWithOptionalTracking>
   );
};

export default view(Home);
